module.exports = __webpack_public_path__ + "static/media/Car parking.d8083bb9.svg";